import { withPagination } from '../../hoc/withPagination';
import ResponsiveTable from './ResponsiveTable';

const factory = (AdditionalActionComponent: $TSFixMe) => withPagination(ResponsiveTable, AdditionalActionComponent);

export default factory;
